import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Injector,
  INJECTOR,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { InputBaseComponent } from '../../base';

@Component({
  encapsulation: ViewEncapsulation.None,
  host: { class: 'pulse-search' },
  selector: 'pulse-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent extends InputBaseComponent implements OnInit {
  form: FormGroup;

  @Output() searchEvent = new EventEmitter<any>();

  constructor(
    @Inject(INJECTOR) private injector: Injector,
    protected override el: ElementRef
  ) {
    super(el);
    this.initForm();
  }

  ngOnInit(): void {}

  initForm() {
    this.form = new FormGroup({
      search: new FormControl(''),
    });
  }

  search() {
    this.searchEvent.emit(this.form.get('search')!.value);
  }
}
